export const NOTIFICATION = {
  GENERATE_COMPLETE: 'generateComplete',
  GENERATE_PROGRESS: 'generateProgress',
  GENERATE_ERROR: 'generateError'
}
